<template>
  <b-taglist>
    <b-tag
      v-for="(filter, index) in filterList.origin"
      :key="filter.id"
      type="is-blue-prussian"
      rounded
      closable
      @close="removeFilterTag('origin', filter.id, index)"
    >
      {{ General.ORGAN }}: {{ filter.data.abbreviation }}
    </b-tag>
    <b-tag
      v-for="(filter, index) in filterList.origin_capacity"
      :key="filter.id"
      type="is-blue-prussian"
      rounded
      closable
      @close="removeFilterTag('origin_capacity', filter.id, index)"
    >
      {{ General.UNITY }}: {{ filter.data.abbreviation }}
    </b-tag>
    <b-tag
      v-if="hasDateStart"
      type="is-blue-prussian"
      rounded
      closable
      @close="removeFilterTag('date', filterList.date.id, 0)"
    >
      {{ General.PERIOD }}:
      <span v-if="hasDateStart">
        {{ filterList.date.data.start | dateFormat("DD/MM/YYYY") }}
      </span>
      -
      <span v-if="hasDateStart">
        {{ filterList.date.data.end | dateFormat("DD/MM/YYYY") }}
      </span>
    </b-tag>
    <b-tag
      v-for="(filter, index) in filterList.subject"
      :key="filter.id"
      type="is-blue-prussian"
      rounded
      closable
      @close="removeFilterTag('subject', filter.id, index)"
    >
      {{ General.SUBJECT }}: {{ filter.data.completeName }}
    </b-tag>
    <b-tag
      v-for="(filter, index) in filterList.reference_number"
      :key="filter.id"
      type="is-blue-prussian"
      rounded
      closable
      @close="removeFilterTag('reference_number', filter.id, index)"
    >
      {{ General.EXTERNAL_PROCESS }}: {{ filter.data.displayText }}
    </b-tag>
  </b-taglist>
</template>

<script>
import { App, General } from "@/utils/constants";
import { getFormattedFilterList } from "@/utils/filterTagsUtility";
import { mapGetters, mapMutations } from "vuex";

export default {
  name: "ConsultProcessFilterTagList",
  data() {
    return {
      App,
      General,
      filterList: []
    };
  },

  computed: {
    ...mapGetters(["getFilterList"]),
    hasDateStart() {
      return this.filterList.date?.data && this.filterList.date?.data.start;
    },
    hasDateEnd() {
      return this.filterList.date?.data && this.filterList.date?.data.end;
    }
  },

  watch: {
    getFilterList({ currentFilterList }) {
      this.filterList = getFormattedFilterList(currentFilterList);
    }
  },

  beforeMount() {
    const { currentFilterList } = this.getFilterList;
    this.filterList = getFormattedFilterList(currentFilterList);
  },

  methods: {
    ...mapMutations(["setFilterList"]),
    removeFilterTag(type, id, index) {
      if (type === "date") {
        this.filterList[type] = {};
        this.filterList = { ...this.filterList };
      } else {
        this.filterList[type] = this.filterList[type].filter(
          (_, index_item) => index_item !== index
        );
      }
      this.setFilterList({
        ...this.getFilterList,
        currentFilterList: this.getFilterList.currentFilterList.filter(
          filter => filter.id !== id
        )
      });
    }
  }
};
</script>
